import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules'
import '../../components/hero/swiper.css'

jQuery(function ($) {
    
    //Swiper.use([Navigation, Pagination, Autoplay, EffectFade])
    
    // initialize swiper when document ready
    const swiperElem = $('#nami-ads')
    if (swiperElem.length === 0) {
        return
    }
    let loopVal = false
    if ($(swiperElem).find('.swiper-slide').length > 1) {
        // loop only if swiper has more than 1 slide
        loopVal = true
    }
    
    const swiper = new Swiper(swiperElem[0], {
        modules: [Navigation, Pagination, Autoplay, EffectFade],
        effect: 'fade',
        fadeEffect: {
        crossFade: true
        },
        speed: 2000,
        loop: loopVal,
        watchOverflow: true,
        autoHeight: false,
        autoplay: {
        delay: 5000,
        disableOnInteraction: true
        }
    })
    swiper.init()
})